module.exports = __webpack_public_path__ + "static/media/arrow-down.d615fda0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/utils/images/arrow-down.svg
// module id = 74
// module chunks = 1